import type { TrackLabel } from './common';

export enum ChannelAudioObserverEvents {
  DominantSpeaker = 'dominant-speaker',
  PeersVolumes = 'peers-volumes',
  Silence = 'silence',
}

export interface DominantSpeakerEvent {
  event: ChannelAudioObserverEvents.DominantSpeaker;
  data: {
    peerId: string;
    producerId: string;
    trackLabel: TrackLabel.Microphone;
  };
}

export interface SilenceEvent {
  event: ChannelAudioObserverEvents.Silence;
}

export interface PeerVolume {
  peerId: string;
  producerId: string;
  value: number;
  trackLabel: TrackLabel.Microphone;
}

export interface PeersVolumesEvent {
  event: ChannelAudioObserverEvents.PeersVolumes;
  volumes: PeerVolume[];
}

export type AudioObserverEvents = DominantSpeakerEvent | SilenceEvent | PeersVolumesEvent;
